import { useState } from 'react'
import { Input } from '@/common/components/Input.tsx'
import { Form } from '@/common/components/Form.tsx'
import { usStates } from '@/common/constants.ts'
import { WizardBodyContainer } from '@/app/pages/program_applications/vendor_application/components/WizardBodyContainer.tsx'
import { WizardStepTitle } from '@/app/pages/program_applications/vendor_application/components/WizardStepTitle.tsx'
import { WizardStepContent } from '@/app/pages/program_applications/vendor_application/components/WizardStepContent.tsx'
import { WizardFooter } from '@/app/pages/program_applications/vendor_application/components/WizardFooter.tsx'
import { useWizardContext } from '@/app/pages/program_applications/vendor_application/WizardProvider.tsx'
import { useTranslation } from 'react-i18next'

const StepId = 3 as const
export default function MailingAddress() {
  const { t: translate } = useTranslation()
  const { setStepCompleted, goNext } = useWizardContext()
  const [isMailingAddressDifferent, setIsMailingAddressDifferent] =
    useState(false)

  const handleRadioChange = (event: { target: { value: string } }) => {
    setIsMailingAddressDifferent(event.target.value === 'yes')
  }
  const validateForm = () => {
    setStepCompleted(StepId)
    goNext()
  }
  return (
    <>
      <WizardBodyContainer>
        <WizardStepTitle>{translate('business_info')}</WizardStepTitle>
        <WizardStepContent>
          <div className="sm:pl-20">
            <h1 className="font-semibold text-md">
              {translate(
                'is_your_mailing_address_different_from_your_business_service_address'
              )}
            </h1>
            <div className="flex flex-row p-4">
              <div className="flex items-center gap-x-3">
                <input
                  id="yes"
                  name="mailingAddress"
                  type="radio"
                  value="yes"
                  checked={isMailingAddressDifferent}
                  onChange={handleRadioChange}
                  className="h-4 w-4 border-gray-600 text-primary-600 focus:ring-primary-600"
                />
                <label
                  htmlFor="yes"
                  className="block text-sm font-medium leading-6"
                >
                  {translate('yes')}
                </label>
              </div>
              <div className="flex items-center pl-4 gap-x-3">
                <input
                  id="no"
                  name="mailingAddress"
                  type="radio"
                  value="no"
                  checked={!isMailingAddressDifferent}
                  onChange={handleRadioChange}
                  className="h-4 w-4 border-gray-600 text-primary-600 focus:ring-primary-600"
                />
                <label
                  htmlFor="no"
                  className="block text-sm font-medium leading-6"
                >
                  No
                </label>
              </div>
            </div>
          </div>

          {isMailingAddressDifferent && (
            <Form className="max-w-xl mx-auto">
              <div className="flex flex-col space-y-2">
                <div>
                  <label
                    htmlFor="address"
                    className="block text-sm font-medium leading-6 text-gray-900"
                  >
                    {translate('address')}
                    <span className="text-danger ml-1">*</span>
                  </label>
                  <div className="mt-2">
                    <Input
                      id="address"
                      name="address"
                      type="text"
                      autoComplete="street-address"
                      required
                    />
                  </div>
                </div>
                <div>
                  <label
                    htmlFor="city"
                    className="block text-sm font-medium leading-6 text-gray-900"
                  >
                    {translate('city')}
                    <span className="text-danger ml-1">*</span>
                  </label>
                  <div className="mt-2">
                    <Input
                      id="city"
                      name="city"
                      type="text"
                      autoComplete="address-level2"
                      required
                    />
                  </div>
                </div>
                <div>
                  <label
                    htmlFor="state"
                    className="block text-sm font-medium leading-6 text-gray-900"
                  >
                    {translate('state')}
                    <span className="text-danger ml-1">*</span>
                  </label>
                  <div className="mt-2">
                    <select
                      id="state"
                      name="state"
                      autoComplete="address-level1"
                      className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-primary-600 sm:max-w-xl sm:text-sm sm:leading-6"
                    >
                      {usStates.map((state) => (
                        <option
                          key={state.abbreviation}
                          value={state.abbreviation}
                        >
                          {state.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div>
                  <label
                    htmlFor="zip"
                    className="block text-sm font-medium leading-6 text-gray-900"
                  >
                    {translate('zip')}
                    <span className="text-danger ml-1">*</span>
                  </label>
                  <div className="my-2 pb-4">
                    <Input
                      id="zip"
                      name="zip"
                      type="number"
                      autoComplete="postal-code"
                      required
                    />
                  </div>
                </div>
              </div>
            </Form>
          )}
        </WizardStepContent>
      </WizardBodyContainer>
      <WizardFooter onNext={validateForm} />
    </>
  )
}
